const de = {
  imprint: "Impressum",
  imprintUrl: "https://molit.eu/impressum/",
  noSecret: "Die Seite kann nicht angezeigt werden, da die Anfrage von einem nicht-authentifizierten System gestellt wurde.",
  save: "Datenspende bestätigen",
  continue: "Weiter",
  status: "Status",
  noEntriesFound: "Keine Einträge gefunden",
  patientForm: {
    patientDetails: "Stammdaten",
    patientAddress: "Adresse des Patienten",
    firstname: "Vorname",
    lastname: "Nachname",
    birthname: "Geburtsname",
    birthdate: "Geburtsdatum",
    gender: {
      gender: "Geschlecht",
      male:"Männlich",
      female: "Weiblich",
      divers: "Divers",
      unknown: "Unbekannt",
      other: "Andere"
    },
    street: "Straße",
    houseNumber: "Hausnummer",
    postCode: "Postleitzahl",
    town: "Ort",
    insuranceNumber: "Versichertennummer",
    caseId: "Fallnummer",
    patientId: "Patienten ID",
    organisation: "Behandelnde Klinik",
    placeholder: {
      select: "Bitte auswählen",
    },
    required: "Bitte wählen Sie eine Antwort aus."
  },
  message: {
    error: {
      e400: "Die Organisation konnte vom Server nicht verifiziert werden.",
      e401: "Sie sind nicht berechtigt, diese Aktion durchzuführen.",
      e403: "Sie sind nicht berechtigt, diese Operation durchzuführen.",
      e404: "Der Server ist nicht erreichbar, bitte probieren Sie es später erneut.",
      e409: "Es ist bereits ein anderer Patient mit dieser Fall-ID oder Patienten-ID angelegt. Bitte überprüfen Sie Ihre Eingaben.",
      e4xx: "Es ist ein Fehler aufgetreten, bitte probieren Sie es später erneut.",
      e5xx: "Es ist ein interner Serverfehler aufgetreten."
    },    
    contactSupport: "Support kontaktieren",
    birthdate_in_future: "Der angegebene Geburtstag liegt in der Zukunft",
    success: "Speichern war erfolgreich!",
    savingInProgress: "Speichern...",
    confirmImplicationSave: "Mit dem Klick auf \"Datenspende bestätigen\" bestätigen Sie, dass der Patient mit seiner Unterschrift zugestimmt hat, seine Daten zu Forschungszwecken zu verwenden wie angegeben.",
    confirmImplicationSaveRequired: "Eine Bestätigung der Zustimmung des Patienten zur Datenspende ist erforderlich."
  },
  consentQuestion: {
    consentTitle: "Einwilligung in die Nutzung von Patientendaten für medizinische Forschungszwecke",
    datenspende: "Erhebung, Verarbeitung und wissenschaftliche Nutzung meiner Patientendaten, wie in der Patienteninformation beschrieben",
    kontaktaufnahme_Zusatzbefunde: " Möglichkeit einer erneuten Kontaktaufnahme (medizinische Zusatzbefunde) ",
    kontaktaufnahme_wissenschaftlich: " Möglichkeit einer erneuten Kontaktaufnahme (wissenschaftliche Fragen) ",
    datenspendeDetail: "Dies umfasst </br> 1.) die Verarbeitung und Nutzung meiner Patientendaten für die medizinische Forschung Verwaltung des Namens und anderer direkt identifizierender Daten (Codierung) wie in der Patienteninformation beschrieben (siehe Punkte 1.1 und 1.2). </br> 2.) die wissenschaftliche Analyse und Nutzung meiner codierten Patientendaten durch Dritte wie z.B. durch andere Kliniken, Universitäten, Institute, forschende Unternehmen; dies kann auch eine Weitergabe für Forschungsprojekte im Ausland umfassen, wenn in diesen europäisches Datenschutzrecht gilt oder die Europäische Kommission ein angemessenes Datenschutzniveau bestätigt hat. An einem etwaigen kommerziellen Nutzen aus der Forschung werde ich nicht beteiligt. Vor einer Weitergabe an Forscher außerhalb meiner behandelnden Einrichtung erfolgt zudem eine weitere Ersetzung des internen Kennzeichens durch eine neue Zeichenkombination. </br> 3.) die Möglichkeit einer Zusammenführung meiner Patientendaten mit Daten in Datenbanken anderer Forschungspartner. Voraussetzung ist, dass ich dieser Nutzung bei den entsprechenden Forschungspartnern auch zugestimmt habe. </br> Ich willige ein in die Erhebung, Verarbeitung, Speicherung und wissenschaftliche Nutzung meiner Patientendaten wie in Punkt (1) bis (3) der Einwilligungserklärung und Punkt 1 der Patienteninformation beschrieben.",
    kontaktaufnahme_Zusatzbefunde_Detail: "Ich willige ein, dass ich wieder kontaktiert werden darf, um über medizinische Zusatzbefunde informiert zu werden (siehe Punkt 2.2 der Patienteninformation).",
    kontaktaufnahme_wissenschaftlich_Detail: "Ich willige ein, dass ich erneut kontaktiert werden darf, um gegebenenfalls zusätzliche für wissenschaftliche Fragen relevante Informationen zur Verfügung zu stellen, um über neue Forschungsvorhaben/Studien informiert zu werden, und/oder um meine Einwilligung in die Verknüpfung meiner Patientendaten mit medizinischen Informationen aus anderen Datenbanken einzuholen (siehe Punkt 2.1 der Patienteninformation).",
    showMore: "mehr anzeigen",
    showLess: "weniger anzeigen",
    yes: "Ja",
    no: "Nein"
  }
};

export default de;
